import { UnitTab } from "../types/data.types";

export const unitTabs = [
  { id: "selling_units", label: "Selling Units", value: 0 as UnitTab },
  { id: "shipping_units", label: "Shipping Units", value: 1 as UnitTab },
  { id: "vendor-units", label: "Vendor Units", value: 2 as UnitTab },
];
